import { DATA_GIF_PATH} from "@/app/utils/config";
import { useNavigate } from "react-router-dom";
import "../smeonboarding.css";
import GxPrimaryButton from "@/app/components/common/actions/buttons/GxPrimaryButton";

const profileCreated = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/onboarding/registerFrom");
  };

  return (
    <div className="gx-smeonboard-card">
      <div className="gx-smeonboard-child">
        <div className="gx-smeonboard-box">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12">
              <div className="gx-login-success-img">
                <img src={`${DATA_GIF_PATH}done_animation.gif`} alt="Success" />
              </div>
            </div>
            <div className="col-span-12">
              <div className="gx-request-progress-title">
                <h2 className="gx-h2-l">
                  Profile Created <br/>
                  <span className="gx-h2-b"> Successfully ! </span>
                </h2>
                <p className="gx-p12-m">Your profile has been created.</p>
              </div>
            </div>
            <div className="col-span-12">
              <div className="gx-footer-btn">
                <GxPrimaryButton
                  handleSubmit={handleContinue}
                  label="CONTINUE"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default profileCreated;
